import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Heading,
  ModalProps,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

interface ConfirmationProps extends Omit<ModalProps, 'children'> {
  title: string;
  description?: string | JSX.Element;
  cta: string;
  action: () => void;
  tone?: 'positive' | 'negative';
}

export function Confirmation({title, description, cta, action, tone = 'negative', ...props}: ConfirmationProps) {
  const t = useTranslate();

  return (
    <Modal {...props} isCentered motionPreset="scale" size="md" closeOnOverlayClick={false}>
      <ModalOverlay />

      <ModalContent
        px="6"
        pt="20"
        pb={[16, null, 10]}
        alignItems="center"
        textAlign="center"
        rounded="md"
        shadow="xs"
        gap="3"
      >
        <ModalHeader p="0">
          <Heading size="sm" fontWeight="800">
            {title}
          </Heading>
        </ModalHeader>
        <ModalCloseButton size="lg" top="4" insetEnd="4" />

        {description && <ModalBody p="0">{description}</ModalBody>}

        <ModalFooter w="full" py="0" px="5" mt="5" gap="2.5" alignItems="center" justifyContent="space-between">
          <Button variant={tone === 'positive' ? 'solid' : 'warn'} w="full" onClick={action} data-testid={props?.id}>
            {cta}
          </Button>

          <Button variant={tone === 'positive' ? 'warn' : 'solid'} w="full" onClick={props.onClose} tabIndex={1}>
            {t('app.actions.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
